import './App.css';
import Header from './components/Header';
import Footer from './components/Footer';
import Accueil from './pages/Accueil';
import Contact from './components/Contact';
import Participation from './components/Participation';
import APropos from './components/APropos'; 
import React, { useState, useEffect } from 'react';
import Speakers from './components/Speakers';
import CongressTopics from './components/CongressTopics';
import NosFlyers from './components/NosFlyers';
import Gestion from './components/Gestion';
import Media from './components/Media';
import Historique from './components/Historique';
import ProgrammeConference from './components/ProgrammeConference';
import PointageAppareil from './components/PointageAppareil';
import ConfirmParticipation from './pages/ConfirmParticipation';
import VideoSidebar from './components/VideoSidebar';
import GSIDAAcademicChallenge from './components/GSIDAAcademicChallenge';
import Formation from './components/Formation';
import ExecutiveFormations from './components/ExecutiveFormations';
import APSISSection from './components/APSISSection';
import Committee from './components/Committee';



function App() {
  const [page, setPage] = useState('accueil');

  // Listen for hash changes and update page state
  useEffect(() => {
    const handleHashChange = () => {
      // Only use the part before '?' for routing
      const hash = window.location.hash.replace('#', '');
      const [hashPage] = hash.split('?'); // <-- split at '?'
      // Map hash to page state
      switch (hashPage) {
        case 'apropos':
          setPage('apropos');
          break;
        case 'committee':
          setPage('committee');
          break;
        case 'programme':
          setPage('programme');
          break;
        case 'speakers':
          setPage('speakers');
          break;
        case 'contact':
          setPage('contact');
          break;
        case 'participation':
          setPage('participation');
          break;
        case 'NosFlyers':
          setPage('NosFlyers');
          break;
        case 'confirm':
          setPage('confirm');
          break;
        case 'challenge':
          setPage('challenge');
          break;
        case 'formations':
          setPage('formations');
          break;
        case 'executive-formations':
          setPage('executive-formations');
          break;
        case 'apsis':
          setPage('apsis');
          break;
        // Add more mappings as needed
        default:
          if (hashPage) {
            setPage(hashPage);
          } else {
            // If no hash, set to accueil
            setPage('accueil');
          }
          break;
      }
    };

    window.addEventListener('hashchange', handleHashChange);

    // On mount, check if there's a hash and set page
    handleHashChange();

    return () => window.removeEventListener('hashchange', handleHashChange);
  }, []);

  // Extract edition year from historique pages
  const getEditionFromPage = (page) => {
    if (page.startsWith('historique-')) {
      return page.replace('historique-', '');
    }
    return null;
  };

  const edition = getEditionFromPage(page);

  return (
    <div className="App">
      <Header onNavigate={setPage} currentPage={page} />
      {page === 'accueil' && <VideoSidebar />}
      
      {page === 'accueil' && <Accueil onNavigate={setPage} />}
      {page === 'contact' && <Contact />}
      {page === 'participation' && <Participation />}
      {page === 'apropos' && <APropos />}
      {page === 'committee' && <Committee />}
      {page === 'speakers' && <Speakers />}
      {page === 'CongressTopics' && <CongressTopics />}
      {page === 'NosFlyers' && <NosFlyers />}
      {page === 'programme' && <ProgrammeConference />}
      {page === 'gestion' && <Gestion />}
      {page === 'media' && <Media />}
      {page === 'pointage' && <PointageAppareil />}
      {page === 'confirm' && <ConfirmParticipation />}
      {page === 'challenge' && (
        <>
          <GSIDAAcademicChallenge />
        </>
        
      )}
      {page === 'formations' && <Formation />}
      {page === 'executive-formations' && <ExecutiveFormations />}
      {page === 'apsis' && <APSISSection />}
      {(page === 'historique' || page.startsWith('historique-')) && <Historique edition={edition} />}

      <Footer />
    </div>
  );
}

export default App;




